// extracted by mini-css-extract-plugin
module.exports = {"site-layout-background":"tabpage-template_site-layout-background__Q3WJi","tabpage-template-body":"tabpage-template_tabpage-template-body__N4tl1"};